import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import UserTenantTypePicker from "@/v2-backoffice-client/user/tenant/type/UserTenantTypePicker"
import { useTenantUserAddMutation } from "@/v2-backoffice-client/tenant/user/add/tenant.user.add.mutation"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import { DEFAULT_TENANT_USER_TYPE_CODE } from "@/v2-backoffice-client/tenant/user/tenant.user.constants"

export type UserTenantManageSearchItemProps = {
  tenant: TenantFragment
  userId: number
  onAdded(roleCode: number): void
}

function UserTenantManageSearchItem(props: UserTenantManageSearchItemProps) {
  const { tenant, userId, onAdded } = props

  const [roleCode, setRoleCode] = useState(DEFAULT_TENANT_USER_TYPE_CODE)
  const [add, { error, loading }] = useTenantUserAddMutation({
    onCompleted() {
      onAdded(roleCode)
    },
  })

  errorToast(error, { title: "Failed to add user to team" })

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={tenant.Name}
        secondary={tenant.CustomerName ?? undefined}
      />
      <UserTenantTypePicker value={roleCode} onChange={setRoleCode} size="xs" />
      <ConfirmButton
        size="xs"
        variant="ghost"
        isSquare
        iconSrc="plus"
        content="Add to team"
        confirmContent="Add?"
        isLoading={loading}
        onConfirm={() => {
          add({
            variables: {
              tenantId: tenant.Id,
              userId,
              userTenantTypeCode: roleCode,
            },
          })
        }}
      />
    </Manage.Item>
  )
}

export default UserTenantManageSearchItem
